import Lottie from "lottie-react";
import bookAnim from "../animations/Book.json";

type LoadingScreenProps = {
  size?: number;
  minHeight?: string | number;
};

export default function LoadingScreen({ size = 260, minHeight = "50vh" }: LoadingScreenProps) {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight }}>
      <Lottie animationData={bookAnim} loop style={{ width: size, height: size }} />
    </div>
  );
}
